<template>
  <shared-step-editor-modal
    :open="open"
    :width="490"
    title="Return to Default"
    closeText="Cancel"
    confirmText="Confirm"
    @confirm="handleConfirm"
    @close="handleClose"
  >
    <div class="modal-send-email__subheader">This will exit the advanced mode and change the content of the post back to its original state.</div>
  </shared-step-editor-modal>
</template>

<script>
import SharedStepEditorModal from '../../shared/SharedStepEditorModal';
export default {
  components: {SharedStepEditorModal},
  props: {
    open: Boolean,
  },

  methods: {
    handleConfirm() {
      this.$emit('confirm');
    },
    handleClose() {
      this.$emit('close');
    },
  },
};
</script>

<style scoped lang="scss"></style>
